import type { StyledComponent } from "@emotion/styled";
import { Chip, type ChipProps } from "@mui/material";
import { styled } from "@mui/material/styles";

const PREFIX = "ChipStyled";
export const classes = {
  root: `${PREFIX}-root`,
};

export const ChipStyled: StyledComponent<ChipProps> = styled(Chip)(({ theme }) => ({
  [`&.${classes.root}`]: {
    height: "18px",
    "& .MuiChip-label": {
      lineHeight: 1,
      padding: "0px 6px",
    },
  },
}));
